module.exports = __webpack_public_path__ + "img/outgoing.5d1be54a.svg";